import PropTypes from "prop-types";
import Link from "next/link";
import SubscribeBlock from "../../subscribe-block";
import { useTranslation } from "next-i18next";
import "../styles/_call-to-action-blog.module.scss";

const CallToActionBlog = (props: { title?: string, isButton?: boolean, isSignupBtn?: boolean,  isDocsBtn?: boolean, docsLink?: string}) => {
    const { t } = useTranslation("common");
    return <>
        <section className={`call-to-action-blog`}>
            <div className={'container'}>
                <div className={'d-flex'}>
                    <h2>{props.title}</h2>
                    {!props.isButton ? <SubscribeBlock/> : props.isSignupBtn ? <div className={"cta-buttons"}>
                        <Link href={"https://app.middleware.io/auth/register/"} target={"_blank"} className={"ahref-btn primary"}>{t('cta.getStarted')}</Link>
                        <Link href={"/demo-request/"} className={"ahref-btn secondary"}>{t('cta.bookDemo')}</Link>
                    </div> :  <div className={"cta-buttons"}><Link href={props.docsLink}
                                                                   target={"_blank"} className={"ahref-btn primary"}>{t('blog.cta.migrationDocs')}</Link></div>}
                    </div>
                        </div>
        </section>
    </>
}
CallToActionBlog.defaultProps = {
    title: "Get our latest articles delivered straight to your inbox",
    isButton: false,
    isSignupBtn: false,
    isDocsBtn: false,
    docsLink: "https://docs.middleware.io"
}

CallToActionBlog.propTypes = {
    title: PropTypes.string,
    isButton: PropTypes.bool,
    isSignupBtn: PropTypes.bool,
    isDocsBtn: PropTypes.bool,
    docsLink: PropTypes.string
}
export default CallToActionBlog